import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchInventoryInvoiceList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        commit('resetInventoryInvoiceOutstandingList')
        axios.post('/inventoryInvoice/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            
            if(res.data.try_again) {
                dispatch('fetchInventoryInvoiceList', payload)
            } else {
                if(payload.show_outstanding) {
                    commit('setInventoryInvoiceOutstandingList', res.data.response)
                } else {
                    commit('setInventoryInvoiceList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
                }   
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const emailInventoryPurchaseList =  ({commit}, payload) => {
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/inventoryInvoice/emailInventoryPurchaseList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchInventoryInvoiceData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/inventoryInvoice/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setInventoryInvoiceData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchVendorPaymentList', {
                store_list: [{store_id: 0}],
                purchase_bill_id: res.data.response.id
            }) 
            dispatch('fetchDocumentList', {purchase_bill_id: payload.id, copy: payload.copy})     
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetInventoryInvoiceData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitInventoryInvoiceData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryInvoice/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {    
            
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchInventoryInvoiceData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryInvoiceData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryInvoice/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack && !payload.popup) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                dispatch('fetchInventoryInvoiceList', payload.list)
            }
            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitGroupInventoryItems = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryInvoice/submitGroupInventoryItems.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('addPurchaseInvoiceItems_Bulk', res.data.response)
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryInvoice/actions.js